import React, { useCallback } from 'react';
import { useAuthentication } from 'components/AuthenticationProvider/AuthenticationProvider';

const RequireAuth = ({
    children,
}: {
    children: React.ReactElement;
}): JSX.Element | null => {
    const { isAuthenticated, login, isLoading } = useAuthentication();

    const handleUnauthenticated = useCallback(() => {
        !isLoading && login();
        return null;
    }, [login, isLoading]);

    return isAuthenticated ? children : handleUnauthenticated();
};

export default RequireAuth;
